import React, { Component } from 'react';
import { Alert, Input, Select, Button, Popover, message, Spin, Tooltip } from 'antd';
import _,{get} from 'lodash';
import DateChoose from '../../../compenents/newDateChoose';
import ProTable from '@ant-design/pro-table'
import { fetchEnums, fetchInvoicePageList, fetchSigoCompany, fetchInvoicePageExportSys, fetchInvoicePageExportManual, fetchSystemInvoice } from '../match/common/api';
import moment from 'moment';
import { outputMoney, getSid, objToArr } from '@/public/utils'
import {transferx0ToX0,toggleFullScreen } from '../match/common/utils'
import './list.less'
import '@/static/style/basetable.less'
import NewPagination from '../../../compenents/newpagination/newpagination';
import {
  FullscreenOutlined
} from '@ant-design/icons'
import ResizeableTitle from '../../../compenents/Resizable/index';
import commons from '../../../public/common';
import { getCookieNew } from '../../../public/utils';
class InvoiceVerificationList extends Component {
  components = {
    header: {
      cell: ResizeableTitle,
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      params: {
        page_size: 10,
        page_no: 1
      },
      selectOption: {
        invoiceStatus: [],
        sigoMainBody: [],
        matchingStatus: [],
        invoiceTypes: [],
        certificationStatus: [],
        certificationTypes: [],
      },
      iptValue: {
        invoice_no: "",
        invoice_id: "",
        invoice_code: "",
        invoice_status_list: [],
        date_type: "1",
        start_date: moment().startOf('day').subtract(89, 'days').valueOf(),
        end_date: moment().subtract(1, 'days').endOf('day').valueOf(),
        buyer_no: "",
        match_id: "",
        matches_status_list: [],
        invoice_type_list: [],
        legalize_type_list: [],
        legalize_state_list: [],
        supplier_no:getCookieNew('supplier_code')||''
      },
    }
  }

  componentDidMount() {
    this.init()
  }

  init = async () => {
    let { selectOption } = this.state
    this.setLoading(true)
    Promise.all([fetchEnums(), fetchSigoCompany()]).then(res => {
      var enums = transferx0ToX0(_.get(res, "[0].data"))
      let invoiceStatus = objToArr(_.get(enums, "发票状态枚举值") || {})
      let matchingStatus = objToArr(_.get(enums, "发票匹配状态枚举值") || {})
      let invoiceTypes = objToArr(_.get(enums, "发票类型枚举值(系统)") || {})
      let certificationStatus = objToArr(_.get(enums, "发票认证状态枚举值") || {})
      let certificationTypes = objToArr(_.get(enums, "认证类型枚举值") || {})
      let sigoMainBody = objToArr(_.get(res, "[1].data.data") || {})
      selectOption.invoiceStatus = invoiceStatus || []
      selectOption.sigoMainBody = sigoMainBody || []
      selectOption.matchingStatus = matchingStatus || []
      selectOption.invoiceTypes = invoiceTypes || []
      selectOption.certificationStatus = certificationStatus || []
      selectOption.certificationTypes = certificationTypes || []
      this.setState({
        loading: false,
        enums,
        selectOption,
      }, () => {
        this.searchClick()
      })
    }).catch(err => {
      this.setLoading(false)
    })
  }

  setLoading = (val) => {
    this.setState({
      loading: val
    })
  }

  iptChange = (e) => {
    let { iptValue } = this.state
    _.set(iptValue, e.target.name, e.target.value)
    this.setState({
      iptValue,
    })
  }

  selectChange = (key, val) => {
    let { iptValue } = this.state
    _.set(iptValue, key, val)
    this.setState({
      iptValue,
    })
  }

  dateChange = (val) => {
    let { iptValue } = this.state
    iptValue.start_date = val[0] ? val[0].valueOf() : ""
    iptValue.end_date = val[1] ? val[1].valueOf() : ""
    this.setState({
      iptValue,
    })
  }

  searchClick = _.debounce(() => {
    let { iptValue, params } = this.state
    params = { ...params, query: iptValue }
    params.page_no = 1
    this.setState({
      params
    }, () => {
      this.getTableData()
    })
  }, 200)

  getTableData = async () => {
    try {
      this.setLoading(true)
      let { params } = this.state
      params.query.sid = getSid()
      params.query.invoice_source = "00"
      let res = await fetchInvoicePageList(params)
      this.setState({
        loading: false,
        data: _.get(res, "data") || {}
      })
    } catch (err) {
      this.setLoading(false)
    }
  }

  pageChage = (val) => {
    let { params } = this.state
    params.page_no = val
    this.setState({
      params,
    }, () => {
      this.getTableData()
    })
  }

  sizeChange = (pageNum, pageSize) => {
    let { params } = this.state
    params.page_size = pageSize
    params.page_no = 1
    this.setState({
      params,
    }, () => {
      this.getTableData()
    })
  }

  getSystemInvoice = async () => {
    try {
      this.setLoading(true)
      let res = await fetchSystemInvoice()
      this.setLoading(false)
      if (_.get(res, "status") === 200) {
        message.success("手动获取成功！")
        this.searchClick()
      }
    } catch (err) {
      this.setLoading(false)
    }
  }

  matchIdListClick = (code,id)=>{
    if(code){
      if(code.includes("PTPD")){
      }else{
        window.open(`${commons.scsWebUrl}main/bill/match/detail?match_id=${code}`)
      }
    }
  }

  exportClick = _.debounce(() => {
    let { params } = this.state
    let _params = _.cloneDeep(params)
    _params.query.invoice_source = "00"
    delete _params.page_no
    delete _params.page_size
    fetchInvoicePageExportSys(_params.query, moment().format("YYYY-MM-DD:HH:mm:ss") + "系统采集.xls")
  }, 200)


  render() {
    let { iptValue, selectOption, data, enums, params } = this.state
    let columns = [
      {
        title: '发票号码',
        dataIndex: 'invoice_no',
        fixed: 'left',
        width: 120,
        align: "left",
        render: (text, record) => {
          return (
            <div>{get(record,'electronic_invoice_no')||text}</div>
          )
        }
      },
      {
        title: '开票日期',
        dataIndex: 'invoice_date',
        align: "center",
        width: 100,
        render: (text, record) => {
          return text ? text.substring(0, 4) + "-" + text.substring(4, 6) + "-" + text.substring(6, 8) : "-"
        },
      },
      {
        title: '结算主体',
        dataIndex: 'buyer_name',
        width: 200
      },
      {
        title: '发票状态',
        width: 100,
        dataIndex: 'invoice_status',
        render: (text, record) => {
          if (text) {
            return (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: `${text / 1 === 0 ? "green" : "red"}`, marginRight: 8 }}></span>
                <span>{enums["发票状态枚举值"][text / 1] || "-"}</span>
              </div>
            )
          } else {
            return '-'
          }
        }
      },
      {
        title: '发票代码',
        width: 120,
        dataIndex: 'invoice_code',
      },
      {
        title: '发票类型',
        dataIndex: 'invoice_type',
        align: "center",
        width: 150,
        render: (text, record) => {
          if (String(text)) {
            return (
              <span>{enums["发票类型枚举值(系统)"][text] || "-"}</span>
            )
          } else {
            return '-'
          }

        }
      },
      {
        title: '含税金额',
        width: 150,
        align: "center",
        dataIndex: 'total_amount',
        render: (text, record) => {
          return (
            <div style={{ textAlign: "right" }}>{outputMoney(text)}</div>
          )
        }
      },
      {
        title: '税额',
        width: 150,
        align: "center",
        dataIndex: 'tax_amount',
        render: (text, record) => {
          return (
            <div style={{ textAlign: "right" }}>{outputMoney(text)}</div>
          )
        }
      },
      {
        title: '已匹配金额',
        width: 150,
        align: "center",
        dataIndex: 'have_match_amount',
        render: (text, record) => {
          return (
            <div style={{ textAlign: "right" }}>{outputMoney(text)}</div>
          )
        }
      },
      {
        title: '未匹配金额',
        width: 150,
        align: "center",
        dataIndex: 'remain_amount',
        render: (text, record) => {
          return (
            <div style={{ textAlign: "right" }}>{outputMoney(text)}</div>
          )
        }
      },
      {
        title: '匹配状态',
        align: "center",
        width: 150,
        dataIndex: 'matches_status',
        render: (text, record) => {
          let colorObj = {
            '00': "grey",
            '01': "green",
            '02': "green",
            '03': "red",
          }
          if (enums["发票匹配状态枚举值"][text]) {
            return (
              <div>
                <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: `${colorObj[text]}`, marginRight: 8 }}></span>
                <span>{enums["发票匹配状态枚举值"][text] || "-"}</span>
              </div>
            )
          } else {
            return '-'
          }

        }
      },
      {
        title: '票单关联号',
        align: "center",
        width: 130,
        dataIndex: 'match_id_list',
        render: (text, record) => {
          if (!_.get(text, "length")) {
            return '-'
          }
          if (_.get(text, "length") > 1) {
            return (
              <Popover
                placement="right"
                content={
                  <div>
                    {
                      (text.filter((item, index) => index != 0) || []).map((_item, _index) => {
                        return (
                          <div key={_index} onClick={() => { this.matchIdListClick(_item) }}>
                            {
                              _item.includes("PTPD")?<span>{_item}</span>: <a >{_item}</a>
                            }
                          </div>
                        )
                      })
                    }
                  </div>
                }
              >
                {
                  (get(text,"[0]")||"").includes("PTPD")?<span>{get(text,"[0]")}</span>:<a onClick={() => { this.matchIdListClick(get(text,"[0]")) }}>{get(text,"[0]")}</a>
                }
              </Popover>
            )
          } else if (_.get(text, "length")) {
            return  (get(text,"[0]")||"").includes("PTPD")?<span>{get(text,"[0]")}</span>:<a onClick={() => { this.matchIdListClick(get(text,"[0]"))}}>{get(text,"[0]") || "-"}</a>
          } else {
            return '-'
          }
        }
      },
      {
        title: '认证状态',
        align: "center",
        width: 90,
        dataIndex: 'legalize_state',
        render: (text, record) => {
          return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: `${text / 1 === 2 ? "green" : "gray"}`, marginRight: 8 }}></span>
              <span>{enums["发票认证状态枚举值"][text / 1] || "-"}</span>
            </div>
          )
        }
      },
      {
        title: '认证日期',
        align: "center",
        width: 90,
        dataIndex: 'legalize_date',
        render: (text, record) => {
          return _.get(text, "length") > 1 ? text.substring(0, 4) + "-" + text.substring(4, 6) + "-" + text.substring(6, 8) : "-"
        }
      },
      {
        title: '认证类型',
        align: "center",
        dataIndex: 'legalize_type_name',
        width: 90,
        render: (text, record) => {
          return text || "-"
          // if ([null, undefined, ""].includes(text)) {
          //   return "-"
          // } else if (enums["认证类型枚举值"][text / 1]) {
          //   return (
          //     <div style={{ display: "flex", alignItems: "center" }}>
          //       <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: `${text / 1 === 0 ? "gray" : "green"}`, marginRight: 8 }}></span>
          //       <span>{enums["认证类型枚举值"][text / 1] || "-"}</span>
          //     </div>
          //   )
          // } else {
          //   return "-"
          // }
        }
      },
    ]
    if (_.get(selectOption, "sigoMainBody.length") <= 1) {
      columns = columns.filter(item => {
        return item.dataIndex !== "buyer_name"
      })
    }
    return (
      <Spin spinning={this.state.loading} id="invoiceVerificationListWap">
        <div className='invoiceVerificationListWap' style={{ background: "#f0f2f5" }}>
          <div style={{ marginBottom: 16 }}>
            <Alert
              message={<div>友情提醒：增值税专用发票开具后需上传税局系统，否则将无法查询到已开票数据进行对账单匹配；若您已上传仍然无法查询数据，请点此<a onClick={this.getSystemInvoice}>手动获取</a>，谢谢！</div>}
              type="warning"
              showIcon
              closable={true}
            />
          </div>
          {/* 搜索区域 */}
          <div className='searchWap'>
            <section style={{ marginRight: 36 }}>
              <span className='key'>发票号码：</span>
              <Input
                value={_.get(iptValue, "invoice_no")}
                name='invoice_no'
                onChange={this.iptChange}
                placeholder='请输入'
                style={{ width: 200 }}
              />
            </section>
            <section style={{ marginRight: 36 }}>
              <span className='key'>发票状态：</span>
              <Select
                allowClear={true}
                showSearch
                placeholder="请选择"
                optionFilterProp="children"
                mode="multiple"
                style={{ width: 200 }}
                value={_.get(iptValue, "invoice_status_list")}
                onChange={this.selectChange.bind(this, "invoice_status_list")}
                filterOption={(input, option) =>
                  (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                }
                options={selectOption.invoiceStatus}
              />
            </section>
            <section>
              {/* 默认开票日期，最近90天的日期 */}
              <Select
                showSearch
                style={{ marginRight: 16 }}
                placeholder="请选择"
                optionFilterProp="children"
                value={_.get(iptValue, "date_type")}
                onChange={this.selectChange.bind(this, "date_type")}
                filterOption={(input, option) =>
                  (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                }
                options={[
                  {
                    value: '1',
                    label: '开票日期',
                  },
                  {
                    value: '2',
                    label: '认证日期',
                  },
                ]}
              />
              <DateChoose
                defaultValue={'ninetyDays'}
                ifConvenient={true}
                isStatus={true}
                isClick={false}
                ifshowClear={true}
                timerChange={this.dateChange}
                time={true}
              />
            </section>
            <div>
              <div>
                {/* <section style={{ marginRight: 36 }}>
                  <span className='key'>发票代码：</span>
                  <Input
                    value={_.get(iptValue, "invoice_code")}
                    name='invoice_code'
                    onChange={this.iptChange}
                    placeholder='请输入'
                    style={{ width: 200 }}
                  />
                </section> */}
                {
                  _.get(selectOption, "sigoMainBody.length") > 1 && (
                    <section style={{ marginRight: 36 }}>
                      <span className='key'>结算主体：</span>
                      <Select
                        allowClear={true}
                        showSearch
                        placeholder="请选择"
                        optionFilterProp="children"
                        style={{ width: 200 }}
                        value={_.get(iptValue, "buyer_no") || null}
                        onChange={this.selectChange.bind(this, "buyer_no")}
                        filterOption={(input, option) =>
                          (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={selectOption.sigoMainBody}
                      />
                    </section>
                  )
                }
                <section style={{ marginRight: 36 }}>
                  <span className='key'>票单关联号：</span>
                  <Input
                    value={_.get(iptValue, "match_id")}
                    name='match_id'
                    onChange={this.iptChange}
                    placeholder='请输入'
                    style={{ width: 200 }}
                  />
                </section>
                <section>
                  <span className='key'>匹配状态：</span>
                  <Select
                    mode="multiple"
                    allowClear={true}
                    value={_.get(iptValue, "matches_status_list")}
                    onChange={this.selectChange.bind(this, "matches_status_list")}
                    options={selectOption.matchingStatus}
                    showSearch
                    placeholder="请选择"
                    optionFilterProp="children"
                    style={{ width: 200 }}
                    filterOption={(input, option) =>
                      (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </section>
                <section style={{ marginRight: 36 }}>
                    <span className='key'>发票类型：</span>
                    <Select
                      mode="multiple"
                      allowClear={true}
                      value={_.get(iptValue, "invoice_type_list")}
                      onChange={this.selectChange.bind(this, "invoice_type_list")}
                      options={selectOption.invoiceTypes}
                      showSearch
                      placeholder="请选择"
                      optionFilterProp="children"
                      style={{ width: 200 }}
                      filterOption={(input, option) =>
                        (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </section>
              </div>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                  <section style={{ marginRight: 36 }}>
                    <span className='key'>认证状态：</span>
                    <Select
                      mode="multiple"
                      allowClear={true}
                      value={_.get(iptValue, "legalize_state_list")}
                      onChange={this.selectChange.bind(this, "legalize_state_list")}
                      options={selectOption.certificationStatus}
                      showSearch
                      placeholder="请选择"
                      optionFilterProp="children"
                      style={{ width: 200 }}
                      filterOption={(input, option) =>
                        (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </section>
                  <section style={{ marginRight: 36 }}>
                    <span className='key'>认证类型：</span>
                    <Select
                      mode="multiple"
                      allowClear={true}
                      value={_.get(iptValue, "legalize_type_list")}
                      onChange={this.selectChange.bind(this, "legalize_type_list")}
                      options={selectOption.certificationTypes}
                      showSearch
                      placeholder="请选择"
                      optionFilterProp="children"
                      style={{ width: 200 }}
                      filterOption={(input, option) =>
                        (_.get(option, "label") || '').toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </section>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <Button onClick={this.searchClick} type="primary" shape="round">查询</Button>
                  <Button onClick={() => { window.location.reload() }} style={{ margin: "0 12px" }} shape="round">重置</Button>
                  <Button onClick={this.exportClick} shape="round">导出</Button>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>
          <div className="componentsTable table boldHeader">
            <ProTable
              rowKey={'invoice_id'}
              pagination={false}
              loading={this.state.loading}
              search={false}
              components={this.components}
              scroll={{ x: 800 }}
              sticky={true}
              options={{ fullScreen: false, density: true, reload: () => { this.getTableData() }, setting: true }}
              toolbar={{
                title: (
                  <Alert message={
                    <div>发票含税金额合计：<span style={{ color: "red" }}>{outputMoney(_.get(data, "data.sum_total_amount"))}</span> 元；税额合计：<span style={{ color: "red" }}>{outputMoney(_.get(data, "data.sum_tax_amount"))}</span> 元；已匹配金额合计：<span style={{ color: "red" }}>{outputMoney(_.get(data, "data.sum_have_match_amount"))}</span> 元，未匹配金额合计：<span style={{ color: "red" }}>{outputMoney(_.get(data, "data.sum_remain_amount"))}</span> 元</div>
                  } type="info" />
                ),
                actions: [
                  <Tooltip placement="top" title="全屏">
                    <FullscreenOutlined
                      style={{
                        width: '1em',
                        height: '1em',
                        cursor: 'pointer',
                        marginLeft: '10px'
                      }}
                      onClick={toggleFullScreen}
                    />
                  </Tooltip>
                ]
              }}
              columns={columns}
              tableAlertRender={false}
              dataSource={_.get(data, "data.list") || []}
              columnEmptyText="-"
            />
            <NewPagination total={_.get(data, "total_count") || 0} current={_.get(params, "page_no")} pagesize={_.get(params, "page_size")} pageChage={this.pageChage} sizeChange={this.sizeChange} />
          </div>
        </div>
      </Spin>
    );
  }
}

export default InvoiceVerificationList;


// WEBPACK FOOTER //
// ./src/pages/billVerification/invoiceVerification/list.jsx